/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { fetchBase, FetchError, FetchSuccess } from "./managers";

export const getFlightById = async (id, eventId) => {
  try {
    const res = await fetchBase(`user-dashboard/flights/${id}`, null, {
      slugTarget: "url",
      eventId,
    });
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};
